<input
  class="text-input"
  type="text"
  autocomplete="off"
  [class.form-error-border]="error"
  [attr.id]="controlId"
  [attr.maxlength]="maxLength"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (input)="handleInput($event)" />
<div class="input-footer" *ngIf="maxLength">
  <ng-content />
  <span class="char-count">{{ (value ?? '').length }}/{{ maxLength }}</span>
</div>
